{
  "pageTitle": "قدم الآن",
  "heroTitle1": "التأهيل",
  "heroTitle2": "المسبق للتقديم",
  "heroSubtitle": "ابدأ خطوتك الأولى نحو الانضمام إلى مدرسة منارة. أكمل نموذج التأهيل المسبق أدناه وسيتواصل معك فريق القبول قريبًا.",
  "parentSection": "معلومات ولي الأمر",
  "childSection": "معلومات الطالب",
  "parentName": "الاسم الكامل لولي الأمر",
  "parentNamePlaceholder": "أدخل اسمك الكامل",
  "email": "البريد الإلكتروني",
  "emailPlaceholder": "you@example.com",
  "phone": "رقم الهاتف",
  "phonePlaceholder": "+20 100 000 0000",
  "phoneHint": "يُفضل واتساب",
  "location": "المحافظة / بلد الإقامة",
  "referral": "كيف سمعت عن منارة؟",
  "childName": "الاسم الكامل للطالب",
  "childNamePlaceholder": "أدخل اسم الطالب الكامل",
  "childEmail": "البريد الإلكتروني للطالب",
  "childEmailPlaceholder": "child@example.com (اختياري)",
  "childEmailHint": "اختياري",
  "dob": "تاريخ الميلاد",
  "grade": "الصف الدراسي الحالي",
  "applyingForGrade": "الصف المتقدم إليه",
  "currentSchool": "اسم المدرسة الحالية",
  "currentSchoolPlaceholder": "مثال: مدرسة القاهرة الجديدة البريطانية",
  "schoolLocation": "بلد المدرسة",
  "schoolType": "نوع المدرسة",
  "nationality": "الجنسية",
  "nationalityOther": "برجاء تحديد الجنسية",
  "nationalityOtherPlaceholder": "اكتب الجنسية",
  "selectPlaceholder": "اختر...",
  "financialAidTitle": "الدعم المادي والمنح متاحة",
  "financialAidText": "تلتزم منارة بدعم الأسر المؤهلة، فالكفاءة وليس التكلفة هي ما يحدد المقعد الدراسي.",
  "submit": "إرسال الاستفسار",
  "submitting": "جاري الإرسال...",
  "successTitle": "تم استلام طلبك بنجاح",
  "successMessage": "سيتواصل فريق القبول معكم قريبًا لاستكمال خطوات التقديم. تم إرسال تأكيد إلى بريدكم الإلكتروني.",
  "referenceNumber": "رقم الطلب",
  "requiredField": "هذا الحقل مطلوب",
  "invalidEmail": "برجاء إدخال بريد إلكتروني صحيح",
  "invalidPhone": "برجاء إدخال رقم هاتف صحيح",
  "invalidDate": "برجاء إدخال تاريخ ميلاد صحيح",
  "recaptchaError": "برجاء التحقق من أنك لست روبوت",
  "genericError": "حدث خطأ. حاول مرة أخرى.",
  "governorates": {
    "cairo": "القاهرة",
    "giza": "الجيزة",
    "alexandria": "الإسكندرية",
    "qalyubia": "القليوبية",
    "dakahlia": "الدقهلية",
    "sharqia": "الشرقية",
    "gharbia": "الغربية",
    "monufia": "المنوفية",
    "beheira": "البحيرة",
    "kafrElSheikh": "كفر الشيخ",
    "damietta": "دمياط",
    "portSaid": "بورسعيد",
    "ismailia": "الإسماعيلية",
    "suez": "السويس",
    "northSinai": "شمال سيناء",
    "southSinai": "جنوب سيناء",
    "faiyum": "الفيوم",
    "beniSuef": "بني سويف",
    "minya": "المنيا",
    "asyut": "أسيوط",
    "sohag": "سوهاج",
    "qena": "قنا",
    "luxor": "الأقصر",
    "aswan": "أسوان",
    "redSea": "البحر الأحمر",
    "newValley": "الوادي الجديد",
    "matrouh": "مطروح",
    "outsideEgypt": "خارج مصر"
  },
  "grades": {
    "kg1": "روضة ١",
    "kg2": "روضة ٢",
    "grade1": "الصف الأول",
    "grade2": "الصف الثاني",
    "grade3": "الصف الثالث",
    "grade4": "الصف الرابع",
    "grade5": "الصف الخامس",
    "grade6": "الصف السادس",
    "grade7": "الصف الأول الإعدادي",
    "grade8": "الصف الثاني الإعدادي",
    "grade9": "الصف الثالث الإعدادي",
    "grade10": "الصف الأول الثانوي",
    "grade11": "الصف الثاني الثانوي",
    "grade12": "الصف الثالث الثانوي"
  },
  "schoolTypes": {
    "public": "حكومية",
    "private": "خاصة",
    "international": "دولية"
  },
  "nationalities": {
    "egyptian": "مصري",
    "other": "أخرى"
  },
  "referrals": {
    "socialMedia": "إنستجرام أو فيسبوك",
    "googleSearch": "بحث جوجل",
    "friendFamily": "صديق أو قريب",
    "schoolEvent": "فعالية أو يوم مفتوح",
    "other": "أخرى"
  }
}
